import { ErrorMessage, Field } from "formik";
import React from "react";

const ConfirmCheckBox = ({ label, name }) => {
  return (
    <div className="col-md-6 mb-3">
      <div className="form-check tw-flex tw-flex-col tw-justify-center">
        <Field
          type="checkbox"
          name={name}
          className="form-check-input !tw-mt-4 tw-cursor-pointer"
          id="confirm"
        />
        <label className="form-check-label tw-cursor-pointer" for="confirm">
          {label}
        </label>
      </div>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

export default ConfirmCheckBox;
